export default __webpack_public_path__ + "static/media/dinner.33fea46c.svg";